<template>
  <div class="ib-main-section">
    <div class="container">
      <a class="ib-back-btn" href="#" @click="$router.back()">Back</a>
      <div class="row">
        <div class="col-md-6 pl-0">
          <div style="padding-top: 77px;">
            <h2 class="listing-page-title">Risk Details</h2>
            <p class="listing-page-desc text-capitalize">{{ type.toLowerCase().split("_").join(" ") }} request</p>

          </div>
        </div>
        <div class="col-md-6 in-page-infographic">
          <img class="img-fluid" alt="icon" :src="require('@/assets/images/claim-policy-right-img.svg')" />
        </div>
      </div>
        <div class="row detail-header ib-align-start">
          <div class="col-md-6 col-lg-4 col-xl-3">
            <div class="detail-header-img">
              <div>
                <img class="img-fluid" :src="policy_detail.product_image" v-if="policy_detail.plan_name != ''" />

              </div>
              <div class="header-circle-img">
                <img class="img-fluid" :src="policy_detail.company.logo">
              </div>
            </div>
          </div>
          <div class="col-md-6 col-lg-6 col-xl-7 pl-lg-0">
            <h3 class="header-title">{{ policy_detail.product.product_name }}
              <small>{{ policy_detail.insurance_sub_type }}</small>

              <small class="ib-card-plan font-10" v-if="policy_detail.product.plan_name != ''">{{ policy_detail.product.plan_name }}</small>
            </h3>
            <div class="" v-if="policy_detail.policy_no != null" style="display: flex">
              <p class="header-td-first" style="margin: 0 ">Policy No: <span>{{ policy_detail.policy_no }}</span></p>
            </div>
            <div class="" v-else>
              <p class="header-td-first">Order No: <span>{{ policy_detail.tcn_no }}</span></p>
            </div>
            <div class="" v-if="policy_detail.policy_no != null">
              <p class="header-td-first">Order Date: <span>{{ formatDate(policy_detail.created_at) }}</span></p>
            </div>
            <div class="">
              <p class="header-td-first">{{ Insured }} Amount: <span>{{ policy_detail.currency }} </span><span style="color: #3d9cbd !important;">{{ priceFormatter(policy_detail.sum_insured) }}</span></p>
            </div>
          </div>
          <div class="col-lg-2">
            <div class="status-in-process text-capitalize mb-3">{{ policy_detail.status }}</div>
            <!--            <div class="">-->
            <!--              <p class="header-td-first">Expiring Premium:</p>-->
            <!--              <h3 class="header-price">{{ policy_detail.currency }}<span>&nbsp;{{ priceFormatter(policy_detail.paid_amount) }}</span></h3>-->
            <!--            </div>-->
          </div>
        </div>
      <div class="col-md-12 tab-pane fade active show" id="home" role="tabpanel" aria-labelledby="home-tab">
        <div class="row px-1">
          <h2 class="claim-sub-heading primary-color pl-2">Risk Detail</h2>
          <table class="table table-borderless">
            <tr>
              <td>
                <p class="claim-row-data claim-row-sub-heading">Risk ID:</p>
                <p class="claim-row-data claim-row-sub-heading">{{ view_risk_detail.id}} </p>
              </td>
              <td v-if="stage_1_data.length > 0" v-for="(data,index) in stage_1_data" :key="index">
                <p class="claim-row-data claim-row-sub-heading">{{data.label}} </p>
                <p class="claim-row-data claim-row-sub-heading">{{data.value}} </p>
              </td>
            </tr>
            <tr>
              <td v-if="stage_2_data.length > 0" v-for="(data,index) in stage_2_data" :key="index">
                <p class="claim-row-data claim-row-sub-heading">{{data.label}} </p>
                <p class="claim-row-data claim-row-sub-heading">{{data.value}} </p>
              </td>
            </tr>
          </table>
        </div>
<!--        <div class="row px-1">-->
<!--          <h2 class="claim-sub-heading primary-color pl-2">Documents</h2>-->
<!--          <table class="table table-borderless">-->
<!--            <tr v-for="(document,index) in documents" :key="index">-->
<!--              <td>-->
<!--                <p class="claim-row-data claim-row-sub-heading">{{document.text}}</p>-->
<!--&lt;!&ndash;                <p class="claim-row-data claim-row-sub-heading">{{document.urls[0].url}} </p>&ndash;&gt;-->
<!--              </td>-->
<!--              <td v-for="(key, index) in document.urls">-->
<!--                <a :href="key.url" target="_blank">-->
<!--                  <div class="claim-data-icon">-->
<!--                    <img class="img-fluid" :src="key.url">-->
<!--                    <p>Document {{ index+1 }}</p>-->
<!--                  </div>-->
<!--                </a>-->
<!--              </td>-->
<!--            </tr>-->
<!--          </table>-->
<!--        </div>-->
        <div class="row px-3" v-if="documents.length > 0"><h2 class="claim-sub-heading">Documents</h2></div>
        <div class="row px-3" v-for="document in documents">
          <div class="col-md-12">
            <div class="row">
              <h4 class="documents-heading" style="text-align:left !important;">{{ document.text.replace(/_/g,' ')}}</h4>
            </div>
            <div class="row in-document-flex">
              <div class="claim-doc-icon" v-for="(key, index) in document.urls">
                <a :href="key.url" target="_blank">
                  <div class="claim-data-icon">
                    <img class="img-fluid" :src="key.url">
                    <p>Document {{ index+1 }}</p>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>


      </div>
    </div>
  </div>
</template>
<script>
  import axios from 'axios';
  import loading from '@/components/Loading/Loading'
  import moment from "moment";
  export default{
    components :{
      loading,
    },
    data(){
      return{
        type: this.$route.params.type,
        quotation_id: this.$route.params.quotation_id,
        policy_detail:{},
        risk_id:this.$route.params.id,
        view_risk_detail:[],
        documents:[],
        stage_1_data:[],
        stage_2_data:[],

      }
    },
    created: function(){
      const self =this;
      self.policyDetail(self.quotation_id);
      self.viewRiskDetail();
    },
    methods:{
      priceFormatter(price) {
        return new Intl.NumberFormat('en-PK').format(price);
      },
      formatDate(date) {
        return moment(date, "YYYY-MM-DD").format('DD-MMM-YYYY');
      },
      async policyDetail(id){
        const self = this;
        self.showLoader = true;
        await axios.get('customer/policy_detail?id=' + id).then(function (resp) {
          self.showLoader = false;
          if (resp.data.code == 200) {
            self.policy_detail = resp.data.data;
          } else {
            $toast.error(resp.data.message, { position: 'top-right' });
            return false;
          }
        }).catch(function (error) {
          self.showLoader = false;
          if(error.data.errors != undefined) {
            error.data.errors.forEach(element => {
              $toast.error(element.message, { position: 'top-right' });
            });
          } else {
            $toast.error(error.data.message, { position: 'top-right' });
          }
        });
      },
       async viewRiskDetail(){
        const self = this;
         await axios.get('customer/risk_detail?customer_quotation_id=' + self.quotation_id + '&quotation_risk_id='+ self.risk_id).then(function (resp) {
          if (resp.data.code == 200) {
            self.view_risk_detail = resp.data.data;
            self.stage_1_data = self.view_risk_detail.form_data.stage_1;
            self.stage_2_data = self.view_risk_detail.form_data.stage_1;
            self.documents = self.view_risk_detail.documents;
            console.log('form_data',self.view_risk_detail.form_data.stage_1[0].label);
          }
        }).catch(function (error) {
          // alert(error)
          if(error.data.errors != undefined) {
            error.data.errors.forEach(element => {
              $toast.error(element.message, { position: 'top-right' });
            });
          } else {
            $toast.error(error.data.message, { position: 'top-right' });
          }
        });
      }
    }
  }
</script>
<style scoped>
  .active {
    display: block !important;
  }
  .tab-pane {
    display: none;
  }
  .primary-color {
    color: #007bff !important;
  }
  .claim-doc-icon p {
    font-family: "Avenir Medium";
    font-size: 14px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    letter-spacing: normal;
    text-align: left;
    color: #4c505d;
    margin-bottom: 0px;
  }
  .claim-data-icon img {
    margin: 0 auto;
  }
  .claim-data-icon img {
    margin: 0 auto;
  }
  /* .claim-data-icon {
    width: 131px;
    height: 134px;
    border-radius: 10px;
    border: solid 1px #e5e5e5;
    background-color: #ffffff;
    box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.17);
    display: flex !important;
    justify-content: space-evenly;
    align-items: center;
    flex-direction: column;
  }
  .claim-data-icon:not(:nth-of-type(1)){
    margin-left: 15px;
    margin-right: 15px;
  } */
  .claim-data-icon img{
    width: 40px;
    margin-top: 8px;
  }
  .claim-row-sub-heading {
    font-family: "Avenir Book";
    font-size: 15px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.38;
    letter-spacing: normal;
    text-align: left;
    padding-left: 20px;
    color: #ef7c94;
    color: #ef7c94 !important;
  }
  .jbl-nav-tabs .nav-item .nav-link:hover, .jbl-nav-tabs .nav-item .nav-link:active, .jbl-nav-tabs .nav-item .nav-link:focus,.jbl-nav-tabs .nav-item {
    border: solid 1px transparent;
    color: #fff !important;
    height: 61px;
    border-radius: 31px;
    background-color: #def3f7;
    display: flex !important;
    align-items: center;
    justify-content: center;
  }
  .jbl-nav-tabs .nav-item .nav-link:hover, .jbl-nav-tabs .nav-item .nav-link:active, .jbl-nav-tabs .nav-item .nav-link:focus,.jbl-nav-tabs .nav-item .active {
    border: solid 1px var(--primary-color);
    background-color: var(--primary-color);
    color: #fff !important;
    height: 61px;
    border-radius: 31px;
    display: flex !important;
    align-items: center;
    justify-content: center;
  }
  .jbl-nav-tabs .nav-item .nav-link {
    color: #5b6770;
  }
  .jbl-nav-tabs {
    border-radius: 31px;
    box-shadow: 0 3px 26px 0 rgba(0, 0, 0, 0.08);
    background-color: #def3f7;
    border: 0;
    font-family: "Avenir Medium";
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.29;
    letter-spacing: normal;
    text-align: left;
    color: #5b6770;
    margin: 20px 0 10px 15px;
    /* padding-top: 1px;
    padding-bottom: 1px; */
  }
  table > tbody > tr, .data-row {
    margin: 10px 0;
    padding: 20px 30.7px 20px 15px;
    border-radius: 10px;
    box-shadow: 0 3px 26px 0 rgba(0, 0, 0, 0.08);
    border: solid 1px #dedada;
    background-color: #ffffff;
  }
  .data-row .action-area {
    text-align: right;
  }
  .data-row .action-area i {
    width: 7.9px;
    height: 14.6px;
    color: #5b6770;
  }
  .claim-sub-heading {
    width: 100%;
    min-height: 54px;
    margin: 20px 0px;
    padding: 16px;
    border-radius: 7px;
    border: dotted 2px #3d9cbd;
    background-color: rgba(61, 156, 189, 0.03);
    font-family: "Avenir Heavy";
    font-size: 16px;
    /* font-weight: 900; */
    text-align: left;
    color: #ef7c94 !important;
  }
  .data-row .claim-sub-heading {
    font-family: "Avenir Heavy";
    font-size: 16px;
    /* font-weight: 900; */
    text-align: left;
    color: #ef7c94 !important;
  }
  .data-row .claim-row-sub-desc {
    color: #5b6770;
  }
  .data-row .status-danger {
    background-color: rgba(30, 203, 16, 0.09);
    font-size: 12px;
    font-stretch: normal;
    font-style: normal;
    color: #1ecb10;
    letter-spacing: normal;
  }
  .data-row .status {
    padding: 6px 24px;
    border-radius: 6px;
    font-family: "Avenir Medium";
  }
  .data-row .claim-row-data {
    font-family: "Avenir Medium";
    font-size: 19px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.37;
    letter-spacing: normal;
    text-align: left;
    color: #5b6770;
  }
  .data-row .claim-row-heading {
    font-family: "Avenir Medium";
    font-size: 22px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.32;
    letter-spacing: normal;
    text-align: left;
    color: #5b6770;
  }
  label {
    position: absolute;
    top: 0;
    right: 1px;
    bottom: 1px;
    left: .5em;
    z-index: 1;
    height: 1em;
    font-size: 13px;
    line-height: 3.5em;
    color: #999;
    white-space: nowrap;
    cursor: text;
    transition:all .1s ease;
  }
  .input-placeholder:focus ~ label, .input-placeholder:valid ~label {
    font-size:11px;
    left:10px;
    top:-10px;
  }
  .input-placeholder:valid ~label {
    color:green;
  }
  .input-placeholder:focus:invalid ~label {
    color:red;
  }
  .table.table-borderless td {
    padding: 1rem 0rem;
  }
  @media (max-width:576px) {
    nav.nav-tabs.jbl-nav-tabs {
      margin: 0 auto;
    }
    .jbl-nav-tabs .nav-item .nav-link:hover, .jbl-nav-tabs .nav-item .nav-link:active, .jbl-nav-tabs .nav-item .nav-link:focus,.jbl-nav-tabs .nav-item {
      border: solid 1px transparent;
      height: 2.2rem;
    }
    .jbl-nav-tabs .nav-item .nav-link:hover, .jbl-nav-tabs .nav-item .nav-link:active, .jbl-nav-tabs .nav-item .nav-link:focus,.jbl-nav-tabs .nav-item .active {
      border: solid 1px #007bff;
      height: 2.2rem;
    }
    .jbl-nav-tabs {
      font-size: 14px;
    }
    .nav-item .nav-link {
      padding: 0.5rem .5rem;
    }
  }
  dd.claim-row-data {
    font-family: "Avenir Medium";
    font-size: 19px;
    font-weight: 500;
    text-align: left;
    color: #5b6770;
    padding-left: 20px;
  }
</style>




// WEBPACK FOOTER //
// src/views/PolicyServicing/Risk/ViewRisk.vue